import { useState } from 'react';
import { read_cookie } from "sfcookies";
import { hostUrl, UseUrlManagerCleanUrl } from "../../../../utils/url-manager";
import { useRefresh, useNotify } from 'react-admin';

type GridLoaderType = {
    loadingData: boolean,
    gridItems: any,
    error: string
}

export const useSubscriptionGridLoader: () => GridLoaderType = (): GridLoaderType => {
    const [loadingData, setLoadingData] = useState<boolean>(true);
    const [gridItems, setGridItems] = useState([]);
    const [error, setError] = useState<string>('');
    if (gridItems.length === 0) {
        const url: string = UseUrlManagerCleanUrl({ url: hostUrl + 'hq/customer/account/subscription/grid-data' });
        const token: string = read_cookie('auth');
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': token,
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            } )
            .then( (data: any): void => {
                setLoadingData(false);
                if (data?.status === 'success') {
                    setGridItems(data?.data);
                }
                if (data?.status === 'error') {
                    setError(data?.message);
                }
                // console.log(data);
            } )
            .catch( (error: Error): void =>  {
                console.log(error);
            } );
    }
    return { loadingData, gridItems, error };
}

type SubscriptionUpdateType = {
    processingSubscriptionUpdater: boolean,
    subscriptionUpdated: boolean,
    updateSubscriptionError: string,
    processSubscriptionUpdate: any
};

export const useUpdateActiveSubscription: () => SubscriptionUpdateType = (): SubscriptionUpdateType => {
    const [ processingSubscriptionUpdater, setProcessingSubscriptionUpdater ] = useState<boolean>(false);
    const [subscriptionUpdated, setSubscriptionUpdated] = useState<boolean>(false);
    const [updateSubscriptionError, setUpdateSubscriptionError] = useState<string>('');
    const refresh: () => void = useRefresh();
    const notify: any = useNotify();

    function processSubscriptionUpdate(subscriptionPayload: any): void {
        setProcessingSubscriptionUpdater(true);
        const url: string = UseUrlManagerCleanUrl({ url: hostUrl + 'hq/customer/account/subscription/update' });
        const token: string = read_cookie('auth');
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(subscriptionPayload),
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': token,
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            } )
            .then( (data: any): void => {
                setProcessingSubscriptionUpdater(false);
                if (data?.status === 'success') {
                    setSubscriptionUpdated(true);
                    notify(data?.message, { 'type': 'success' });
                    refresh();
                }
                if (data?.status === 'error') {
                    setUpdateSubscriptionError(data?.message);
                }
                // console.log(data);
            } )
            .catch( (error: Error): void =>  {
                console.log(error);
            } );
    }

    return { processingSubscriptionUpdater, subscriptionUpdated, updateSubscriptionError, processSubscriptionUpdate };
}

type SubscriptionCancelType = {
    processingCancel: boolean,
    cancelError: string,
    cancelSubscription: any,
    isCancelled: boolean
};

export const useActiveSubscriptionCancel: () => SubscriptionCancelType = (): SubscriptionCancelType => {
    const [processingCancel, setProcessingCancel] = useState<boolean>(false);
    const [cancelError, setCancelError] = useState<string>('');
    const [isCancelled, setIsCancelled] = useState<boolean>(false);
    const refresh: () => void = useRefresh();
    const notify: any = useNotify();

    function cancelSubscription(subscriptionId: string): void {
        setProcessingCancel(true);
        const url: string = UseUrlManagerCleanUrl({ url: hostUrl + 'hq/customer/account/subscription/cancel' });
        const token: string = read_cookie('auth');
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify({ id: subscriptionId }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': token,
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            } )
            .then( (data: any): void => {
                setProcessingCancel(false);
                if (data?.status === 'success') {
                    notify(data?.message, { 'type': 'success' });
                    setIsCancelled(true);
                    refresh();
                }
                if (data?.status === 'error') {
                    setCancelError(data?.message);
                }
                // console.log(data);
            } )
            .catch( (error: Error): void =>  {
                console.log(error);
            } );
    }

    return { processingCancel, cancelError, cancelSubscription, isCancelled };
}
